import React, { useState } from 'react';
import { Col, Row, Form, Button } from 'react-bootstrap';
import { Typewriter } from 'react-simple-typewriter';
import '../../styles/login.scss';
import { useDispatch } from 'react-redux';
import { forgotPassword } from '../../redux/slices/authSlice';
import { toast } from 'react-toastify';
import Logo from '../../assets/logo7.png'

const ForgotPassword = () => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    email: '',
  });

  // Handle input field changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(forgotPassword(formData))
      .unwrap()
      .then(() => {
        toast.success('Password reset link sent! Please check your email.');
        // setTimeout(() => navigate('/dashboard'), 2000);
        setFormData({ email: '' });
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  return (
    <Row className="login-row">
      {/* Left Side */}
      <Col md={6} className="login-left">
        <div className="overlay"></div>
        <div className="login-left-content">
         <img className='logo' src={Logo} alt='logo'/>
          <h2 className="typing-text">
            <Typewriter
              words={[
                'Discover amazing art.',
                'Connect with artists worldwide.',
                'Join our creative community.',
              ]}
              loop={true}
              cursor
              cursorStyle="_"
              typeSpeed={70}
              deleteSpeed={50}
              delaySpeed={1500}
            />
          </h2>
        </div>
      </Col>

      {/* Right Side: Login Form */}
      <Col md={6} className="login-right">
        <div className="login-form-container">
          <h2>Reset Password</h2>
          <Form onSubmit={handleSubmit}>
            {/* Email */}
            <Form.Group className="mb-4" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                className="form-input"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            {/* Submit */}
            <Button type="submit" className="w-100 login-btn mb-3">
              Reset Password
            </Button>
          </Form>
        </div>
      </Col>
    </Row>
  );
};

export default ForgotPassword;
